export default "__VITE_ASSET__kCWUimTJ__"